import {ReactNode} from 'react'

export type PropsWithChildren<P = unknown> = P & { children: ReactNode }
export type PropsWithOptionalChildren<P = unknown> = P & { children?: ReactNode }
export type Same<T extends U, U extends V, V = T> = void

export enum EDIT_ACTIVITY {
    bulk = 'bulk', single = 'single'
}